module.exports = __webpack_public_path__ + "static/project-3077954e3f526474eff53e16f2724cd1.png";